import PhonecallContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/PhonecallContent";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import ScenarioLibrary from "../../../ngt/scenario/ScenarioLibrary";
import ChapterLibrary from "../../chapters/model/ChapterLibrary";
import ProgressModel from "../../progress/model/ProgressModel";
import PromiseUtil from "../../util/PromiseUtil";
import ConversationReflectionEvent from "../event/ConversationReflectionEvent";
import ConversationReflectionPlayer from "./ConversationReflectionPlayer";
import ConversationReflectionPlayerFactory from "./ConversationReflectionPlayerFactory";

export default class PlayConversationReflectionCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {ConversationReflectionPlayerFactory} conversationReflectionPlayerFactory 
     * @param {ScenarioLibrary} scenarioLibrary 
     * @param {ChapterLibrary} chapterLibrary 
     * @param {ProgressModel} progressModel 
     */
    constructor(dispatcher, conversationReflectionPlayerFactory, scenarioLibrary, chapterLibrary, progressModel) {
        super(dispatcher);

        this._conversationReflectionPlayerFactory = conversationReflectionPlayerFactory;
        this._scenarioLibrary = scenarioLibrary;
        this._chapterLibrary = chapterLibrary;
        this._progressModel = progressModel;

        /** @type {ConversationReflectionPlayer} */
        this._conversationReflectionPlayer = null;

        this._handleConversationReflectionCompletedBound = this._handleConversationReflectionCompleted.bind(this);
    }

    async execute(evt) {
        /** @type {ScenarioPlayerEvent} */
        const data = evt.params.data;
        const { content, contentPlayer } = data;

        /** @type {PhonecallContent} */
        this._content = content;
        /** @type {NGTScenarioPlayer} */
        this._contentPlayer = contentPlayer;

        const chapterId = this._chapterLibrary.getCurrentChapter().id;
        const conversationId = this._content.getDialogID();
        const showTransition = this._content.getIncoming();

        this._conversationReflectionPlayer = this._conversationReflectionPlayerFactory.create();
        const backgroundImageId = this._scenarioLibrary.getCurrentScenario()?.reflectionBackgroundImageId;

        this._dispatcher.addEventListener(ConversationReflectionEvent.COMPLETED, this._handleConversationReflectionCompletedBound);

        this._screenSkin = this.openScreen(SkinKeyRegistry.CONVERSATION_REFLECTION_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        }, {
            conversationReflectionPlayer: this._conversationReflectionPlayer,
            backgroundImageId,
            hideCoachUntilFirstMessage: showTransition,
        });

        await this._conversationReflectionPlayer.start(chapterId, conversationId);
        await this._conversationReflectionPlayer.next();
    }

    async _handleConversationReflectionCompleted(evt) {
        this._dispatcher.removeEventListener(ConversationReflectionEvent.COMPLETED, this._handleConversationReflectionCompletedBound);

        const conversationId = this._content.getDialogID();
        this._progressModel.saveReflectionProgress(conversationId, this._conversationReflectionPlayer.conversation);

        this._conversationReflectionPlayer.end();
        this._conversationReflectionPlayer.destroy();
        this._conversationReflectionPlayer = null;

        const transitionDuration = 450;
        this.closeScreen(this._screenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, transitionDuration, createjs.Ease.sineInOut),
        });

        await PromiseUtil.delay(transitionDuration);
        this._contentPlayer.contentCompleted(this._content);
    }
}